import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { selectVulnDetail } from 'store/ManageGeneral/selectors';
import { updateVulnGeneral } from 'store/ManageGeneral/actions';
import CustomList from 'Common/Components/CustomList';
import ExpandableWrapper from '../ExpandableWrapper';
import Wrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/References/styled';
import useExpandable from 'Hooks/useExpandable';

const TAB = 'general';
const ID = 'references';

const References = () => {
  const dispatch = useDispatch();
  const currentVuln = useSelector(selectVulnDetail);
  const list = get(currentVuln, 'refs', []);
  const intl = useIntl();
  const isExpanded = useExpandable(TAB, ID, list, currentVuln?._id);

  const refsList = list.map((ref) => ref && ref.name);
  const onAdd = (valueAdded) => {
    const newRefs = [...refsList, valueAdded];
    dispatch(updateVulnGeneral(currentVuln, 'refs', newRefs));
  };
  const onRemove = (indexToRemove) => {
    const newRefs = refsList.filter((ref, index) => index !== indexToRemove);
    dispatch(updateVulnGeneral(currentVuln, 'refs', newRefs));
  };

  return (
    <ExpandableWrapper defaultValue={ isExpanded } id="references" title={ intl.formatMessage({ id: 'manage.detail.tab.general.references' }) } tab={ TAB }>
      <Wrapper>
        <CustomList
          key="DETAIL_CREATION_MODAL"
          placeholder="Add a Reference"
          addItem={ onAdd }
          removeItem={ onRemove }
          listData={ refsList }
          responsive
          canUpdate
        />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default References;
